import React from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';

const TableFooter = ({ children }) => {
    return (
        <Plugin>
            <Template name='footer' className="responsive-footer">
                <div className={'card-header table-search-results py-2 d-flex dx-g-bs4-toolbar' }>

                    <div className='c-black'>
                        <span>{children}</span>
                    </div>
                </div>
                <div className="responsive-footer">
                    <TemplatePlaceholder />
                </div>
            </Template>
        </Plugin>
    );
};

export default TableFooter;
